import { gql } from '@apollo/client';

export const GET_INSURANCE_POLICY_QUERY = gql`
  query GetInsurancePolicy($policyId: ID!) {
    insurancePolicy(policyId: $policyId) {
      success
      policy {
        id
        name
        carrierName
        policyType
        policyDurationMonths
        effectiveDate
        expiryDate
        isExpired
        totalPremiumCents
        monthlyPremiumCents
        updatedAt
        vehicles {
          garagingAddress {
            zip
            state
          }
        }
        dwellings {
          id
          address {
            state
          }
        }
      }
    }
    insurancePolicyOverrides(policyId: $policyId) {
      id
      overrides {
        policy {
          zipCode
        }
      }
    }
  }
`;

export const INSURANCE_POLICY_OVERRIDES_QUERY = gql`
  query GetInsurancePolicyOverrides($policyId: ID!) {
    tuCreditReportIdentityProfile {
      vantageScore3
    }
    insurancePolicyOverrides(policyId: $policyId) {
      id
      policy {
        id
        type
      }
      overrides {
        global {
          birthdate
          creditScore
          gender
        }
        policy {
          carYear
          carMake
          carModel
          zipCode
          yearBuilt
        }
      }
    }
  }
`;

export const UPDATE_INSURANCE_POLICY_OVERRIDES_MUTATION = gql`
  mutation UpdateInsurancePolicyOverrides(
    $policyId: ID!
    $globalOverrides: GlobalInsurancePolicyOverridesInput!
    $localOverrides: LocalInsurancePolicyOverridesInput!
  ) {
    updateInsurancePolicyOverrides(
      policyId: $policyId
      globalOverrides: $globalOverrides
      localOverrides: $localOverrides
    ) {
      id
      policy {
        id
        type
      }
      overrides {
        global {
          birthdate
          creditScore
          gender
        }
        policy {
          carYear
          carMake
          carModel
          yearBuilt
          zipCode
        }
      }
    }
  }
`;
